import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'loanBorrow'
})
export class LoanBorrowPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'LN':
        return 'Loan';
      case 'BW':
        return 'Borrow';
      default:
        return value;
    }
  }

}
